module.exports = __webpack_public_path__ + "img/square-table-1.60d71ac1.png";